var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-page" },
    [
      _c("div", { staticClass: "home-header" }, [
        _c("div", { staticClass: "header-content" }, [
          _c("div", { staticClass: "header-top" }, [
            _c("div", { staticClass: "logo-area" }, [
              _c(
                "svg",
                {
                  staticClass: "jj-logo",
                  attrs: {
                    viewBox: "0 0 216 30",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M45.3061 20.8646C43.775 20.8646 42.9213 19.4147 42.9213 16.7914C42.9213 14.1274 43.775 12.7182 45.3061 12.7182C46.8373 12.7182 47.691 14.1491 47.691 16.7914C47.6883 19.4553 46.8346 20.8646 45.3061 20.8646ZM45.3061 11.6261C42.1869 11.6261 40.4579 13.9513 40.4579 16.7914C40.4579 19.6315 42.1869 21.9567 45.3061 21.9567C48.4254 21.9567 50.1544 19.6315 50.1544 16.7914C50.1544 13.9513 48.4254 11.6261 45.3061 11.6261ZM66.9809 11.6261C65.5094 11.6261 64.6964 12.2629 64.2384 13.0759H64.1191V11.8239H61.775V21.7589H64.1191V15.3415C64.1191 13.8727 64.8752 13.0163 66.0866 13.0163C67.2601 13.0163 67.775 13.7914 67.775 14.9648V21.7589H70.1191V14.9431C70.1219 12.8971 69.0487 11.6261 66.9809 11.6261ZM75.4444 11.6261C73.279 11.6261 71.6503 12.5394 71.6503 14.4879C71.6503 16.1383 72.7831 17.0326 74.0541 17.3497L76.0406 17.8456C77.0948 18.103 77.5717 18.4824 77.5717 19.3171C77.5717 20.3307 76.8563 20.9079 75.6042 20.9079C74.2519 20.9079 73.5582 20.2521 73.3387 18.6044L71.233 19.2006C71.3522 20.9106 72.943 21.9621 75.3468 21.9621C78.0297 21.9621 79.4796 20.7101 79.4796 18.7236C79.4796 16.8564 78.1869 16.0814 76.8373 15.7426L74.9294 15.2656C73.9755 15.0272 73.5582 14.5908 73.5582 13.954C73.5582 13.1599 74.233 12.683 75.2465 12.683C76.4389 12.683 77.1733 13.3388 77.2736 14.5908L79.2601 13.9946C79.0216 12.599 77.6503 11.6261 75.4444 11.6261ZM85.3007 20.8646C83.7696 20.8646 82.9159 19.4147 82.9159 16.7914C82.9159 14.1274 83.7696 12.7182 85.3007 12.7182C86.8319 12.7182 87.6855 14.1491 87.6855 16.7914C87.6855 19.4553 86.8292 20.8646 85.3007 20.8646ZM85.3007 11.6261C82.1815 11.6261 80.4525 13.9513 80.4525 16.7914C80.4525 19.6315 82.1815 21.9567 85.3007 21.9567C88.42 21.9567 90.149 19.6315 90.149 16.7914C90.149 13.9513 88.42 11.6261 85.3007 11.6261ZM96.7452 11.6261C95.2736 11.6261 94.4606 12.2629 94.0026 13.0759H93.8834V11.8239H91.5392V21.7589H93.8834V15.3415C93.8834 13.8727 94.6395 13.0163 95.8509 13.0163C97.0243 13.0163 97.5392 13.7914 97.5392 14.9648V21.7589H99.8834V14.9431C99.8834 12.8971 98.8102 11.6261 96.7452 11.6261ZM131.574 20.8646C130.043 20.8646 129.19 19.4147 129.19 16.7914C129.19 14.1274 130.043 12.7182 131.574 12.7182C133.106 12.7182 133.959 14.1491 133.959 16.7914C133.959 19.4553 133.103 20.8646 131.574 20.8646ZM131.574 11.6261C128.455 11.6261 126.726 13.9513 126.726 16.7914C126.726 19.6315 128.455 21.9567 131.574 21.9567C134.694 21.9567 136.423 19.6315 136.423 16.7914C136.423 13.9513 134.694 11.6261 131.574 11.6261ZM153.249 11.6261C151.778 11.6261 150.965 12.2629 150.507 13.0759H150.387V11.8239H148.043V21.7589H150.387V15.3415C150.387 13.8727 151.144 13.0163 152.355 13.0163C153.528 13.0163 154.043 13.7914 154.043 14.9648V21.7589H156.387V14.9431C156.39 12.8971 155.317 11.6261 153.249 11.6261ZM161.715 11.6261C159.55 11.6261 157.921 12.5394 157.921 14.4879C157.921 16.1383 159.054 17.0326 160.325 17.3497L162.312 17.8456C163.366 18.103 163.843 18.4824 163.843 19.3171C163.843 20.3307 163.127 20.9079 161.875 20.9079C160.523 20.9079 159.829 20.2521 159.61 18.6044L157.504 19.2006C157.623 20.9106 159.214 21.9621 161.618 21.9621C164.301 21.9621 165.751 20.7101 165.751 18.7236C165.751 16.8564 164.458 16.0814 163.108 15.7426L161.2 15.2656C160.247 15.0272 159.829 14.5908 159.829 13.954C159.829 13.1599 160.504 12.683 161.518 12.683C162.71 12.683 163.444 13.3388 163.545 14.5908L165.531 13.9946C165.29 12.599 163.919 11.6261 161.715 11.6261ZM171.569 20.8646C170.038 20.8646 169.184 19.4147 169.184 16.7914C169.184 14.1274 170.038 12.7182 171.569 12.7182C173.1 12.7182 173.954 14.1491 173.954 16.7914C173.954 19.4553 173.097 20.8646 171.569 20.8646ZM171.569 11.6261C168.45 11.6261 166.721 13.9513 166.721 16.7914C166.721 19.6315 168.45 21.9567 171.569 21.9567C174.688 21.9567 176.417 19.6315 176.417 16.7914C176.417 13.9513 174.688 11.6261 171.569 11.6261ZM183.013 11.6261C181.542 11.6261 180.729 12.2629 180.271 13.0759H180.152V11.8239H177.807V21.7589H180.152V15.3415C180.152 13.8727 180.908 13.0163 182.119 13.0163C183.293 13.0163 183.807 13.7914 183.807 14.9648V21.7589H186.152V14.9431C186.152 12.8971 185.078 11.6261 183.013 11.6261ZM39.0677 7.85101H36.6042V18.122C36.6042 19.7914 35.9674 20.7833 34.4579 20.7833C32.9674 20.7833 32.3116 19.7291 32.3116 17.9215V16.0136L29.8481 16.6288V17.4824C29.8481 20.0841 31.1408 22.0732 34.4579 22.0732C37.775 22.0732 39.0677 20.0868 39.0677 17.4824V7.85101ZM53.8888 7.85101H51.5446V21.7589H53.8888V15.3415C53.8888 13.8727 54.6449 13.0163 55.8563 13.0163C57.0297 13.0163 57.5446 13.7914 57.5446 14.9648V21.7589H59.8888V14.9431C59.8888 12.8971 58.8156 11.6261 56.7506 11.6261C55.279 11.6261 54.466 12.2629 54.008 13.0759H53.8888V7.85101ZM125.336 7.85101H122.873V18.122C122.873 19.7914 122.236 20.7833 120.726 20.7833C119.236 20.7833 118.58 19.7291 118.58 17.9215V16.0136L116.116 16.6288V17.4824C116.116 20.0841 117.409 22.0732 120.726 22.0732C124.043 22.0732 125.336 20.0868 125.336 17.4824V7.85101ZM140.157 7.85101H137.813V21.7589H140.157V15.3415C140.157 13.8727 140.913 13.0163 142.125 13.0163C143.298 13.0163 143.813 13.7914 143.813 14.9648V21.7589H146.157V14.9431C146.157 12.8971 145.084 11.6261 143.019 11.6261C141.547 11.6261 140.734 12.2629 140.276 13.0759H140.157V7.85101ZM107.612 20.6261C105.705 20.6261 104.534 19.0759 104.534 17.4282C104.534 16.3957 104.992 15.4418 105.745 14.9052L110.236 19.8131C109.401 20.309 108.466 20.6261 107.612 20.6261ZM111.984 18.1816L108.089 13.8889C108.786 13.6098 109.461 13.5123 110.016 13.5123C111.626 13.5123 112.618 14.4472 112.618 16.057C112.621 16.7724 112.42 17.5068 111.984 18.1816ZM107.553 13.3144L106.699 12.3605C105.943 11.5258 105.726 11.0082 105.726 10.393C105.726 9.24125 106.461 8.58543 107.612 8.58543C108.786 8.58543 109.48 9.26022 109.48 10.4933C109.48 11.6261 108.924 12.6992 107.553 13.3144ZM107.672 7.53394C104.929 7.53394 103.58 9.0651 103.58 10.9702C103.58 12.0028 104.016 13.038 105.171 14.2873L105.19 14.328C103.244 15.2629 102.35 16.7724 102.35 18.3226C102.35 20.3686 103.919 22.0787 106.344 22.0787C107.734 22.0787 109.363 21.5014 110.835 20.4689L112.027 21.7616H115.146V21.6613L112.604 18.8591C113.677 17.5881 114.293 16.1979 114.293 14.9838C114.293 13.4743 113.279 12.4608 111.691 12.4608C110.856 12.4608 109.921 12.6992 109.306 12.9377L109.266 12.8591C110.775 12.0434 111.412 11.29 111.412 10.2358C111.406 8.72635 110.057 7.53394 107.672 7.53394Z",
                      fill: "#d51900"
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "header-actions" },
              [
                _c(
                  "div",
                  { staticClass: "scan-btn", on: { click: _vm.scan } },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "scan-icon",
                        attrs: {
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M3 7V5C3 3.89543 3.89543 3 5 3H7",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M17 3H19C20.1046 3 21 3.89543 21 5V7",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M21 17V19C21 20.1046 20.1046 21 19 21H17",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M7 21H5C3.89543 21 3 20.1046 3 19V17",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round"
                          }
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: {
                            x1: "3",
                            y1: "12",
                            x2: "21",
                            y2: "12",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "7",
                            y: "7",
                            width: "4",
                            height: "4",
                            rx: "0.5",
                            fill: "currentColor"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "13",
                            y: "7",
                            width: "4",
                            height: "4",
                            rx: "0.5",
                            fill: "currentColor"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "7",
                            y: "13",
                            width: "4",
                            height: "4",
                            rx: "0.5",
                            fill: "currentColor"
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "edit-profile",
                    attrs: {
                      to: { path: "/register", query: { type: "edit" } }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.user_details.name
                            ? _vm.user_details.name.charAt(0)
                            : "我"
                        )
                      )
                    ])
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "user-greeting-row" }, [
            _c("div", { staticClass: "user-greeting" }, [
              _c("span", { staticClass: "greeting-text" }, [
                _vm._v("欢迎回来，")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "greeting-name" }, [
                _vm._v(_vm._s(_vm.user_details.name || "学员"))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "platform-guide-mini",
                on: { click: _vm.openPlatformGuide }
              },
              [
                _c("span", { staticClass: "guide-mini-icon" }, [_vm._v("🎬")]),
                _vm._v(" "),
                _c("span", { staticClass: "guide-mini-text" }, [
                  _vm._v("平台操作指引")
                ])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "banner-section" },
        [
          _c(
            "van-swipe",
            {
              staticClass: "banner-swipe",
              attrs: { autoplay: 4000, "indicator-color": "#fff" }
            },
            [
              _vm._l(_vm.bannerList, function(banner, index) {
                return _c(
                  "van-swipe-item",
                  {
                    key: index,
                    on: {
                      click: function($event) {
                        return _vm.onBannerClick(banner)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "banner-item" }, [
                      _c("img", {
                        attrs: { src: banner.image, alt: banner.title }
                      }),
                      _vm._v(" "),
                      banner.title
                        ? _c("div", { staticClass: "banner-overlay" }, [
                            _c("span", { staticClass: "banner-title" }, [
                              _vm._v(_vm._s(banner.title))
                            ]),
                            _vm._v(" "),
                            banner.desc
                              ? _c("span", { staticClass: "banner-desc" }, [
                                  _vm._v(_vm._s(banner.desc))
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _vm.bannerList.length === 0
                ? _c("van-swipe-item", [
                    _c("div", { staticClass: "banner-item banner-default" }, [
                      _c("div", { staticClass: "banner-default-bg" }, [
                        _c("div", { staticClass: "bg-circle bg-circle-1" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "bg-circle bg-circle-2" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "bg-circle bg-circle-3" })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "banner-default-content" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "banner-jj-logo",
                            attrs: {
                              viewBox: "0 0 216 30",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M45.3061 20.8646C43.775 20.8646 42.9213 19.4147 42.9213 16.7914C42.9213 14.1274 43.775 12.7182 45.3061 12.7182C46.8373 12.7182 47.691 14.1491 47.691 16.7914C47.6883 19.4553 46.8346 20.8646 45.3061 20.8646ZM45.3061 11.6261C42.1869 11.6261 40.4579 13.9513 40.4579 16.7914C40.4579 19.6315 42.1869 21.9567 45.3061 21.9567C48.4254 21.9567 50.1544 19.6315 50.1544 16.7914C50.1544 13.9513 48.4254 11.6261 45.3061 11.6261ZM66.9809 11.6261C65.5094 11.6261 64.6964 12.2629 64.2384 13.0759H64.1191V11.8239H61.775V21.7589H64.1191V15.3415C64.1191 13.8727 64.8752 13.0163 66.0866 13.0163C67.26 13.0163 67.775 13.7914 67.775 14.9648V21.7589H70.1191V14.9431C70.1219 12.8971 69.0487 11.6261 66.9809 11.6261ZM75.4444 11.6261C73.279 11.6261 71.6503 12.5394 71.6503 14.4879C71.6503 16.1383 72.7831 17.0326 74.0541 17.3497L76.0406 17.8456C77.0948 18.103 77.5717 18.4824 77.5717 19.3171C77.5717 20.3307 76.8563 20.9079 75.6042 20.9079C74.2519 20.9079 73.5582 20.2521 73.3387 18.6044L71.233 19.2006C71.3522 20.9106 72.943 21.9621 75.3468 21.9621C78.0297 21.9621 79.4796 20.7101 79.4796 18.7236C79.4796 16.8564 78.1869 16.0814 76.8373 15.7426L74.9294 15.2656C73.9755 15.0272 73.5582 14.5908 73.5582 13.954C73.5582 13.1599 74.233 12.683 75.2465 12.683C76.4389 12.683 77.1733 13.3388 77.2736 14.5908L79.2601 13.9946C79.0216 12.599 77.6503 11.6261 75.4444 11.6261ZM85.3007 20.8646C83.7696 20.8646 82.9159 19.4147 82.9159 16.7914C82.9159 14.1274 83.7696 12.7182 85.3007 12.7182C86.8319 12.7182 87.6855 14.1491 87.6855 16.7914C87.6855 19.4553 86.8292 20.8646 85.3007 20.8646ZM85.3007 11.6261C82.1815 11.6261 80.4525 13.9513 80.4525 16.7914C80.4525 19.6315 82.1815 21.9567 85.3007 21.9567C88.42 21.9567 90.149 19.6315 90.149 16.7914C90.149 13.9513 88.42 11.6261 85.3007 11.6261ZM96.7452 11.6261C95.2736 11.6261 94.4606 12.2629 94.0026 13.0759H93.8834V11.8239H91.5392V21.7589H93.8834V15.3415C93.8834 13.8727 94.6395 13.0163 95.8509 13.0163C97.0243 13.0163 97.5392 13.7914 97.5392 14.9648V21.7589H99.8834V14.9431C99.8834 12.8971 98.8102 11.6261 96.7452 11.6261ZM131.574 20.8646C130.043 20.8646 129.19 19.4147 129.19 16.7914C129.19 14.1274 130.043 12.7182 131.574 12.7182C133.106 12.7182 133.959 14.1491 133.959 16.7914C133.959 19.4553 133.103 20.8646 131.574 20.8646ZM131.574 11.6261C128.455 11.6261 126.726 13.9513 126.726 16.7914C126.726 19.6315 128.455 21.9567 131.574 21.9567C134.694 21.9567 136.423 19.6315 136.423 16.7914C136.423 13.9513 134.694 11.6261 131.574 11.6261ZM153.249 11.6261C151.778 11.6261 150.965 12.2629 150.507 13.0759H150.387V11.8239H148.043V21.7589H150.387V15.3415C150.387 13.8727 151.144 13.0163 152.355 13.0163C153.528 13.0163 154.043 13.7914 154.043 14.9648V21.7589H156.387V14.9431C156.39 12.8971 155.317 11.6261 153.249 11.6261ZM161.715 11.6261C159.55 11.6261 157.921 12.5394 157.921 14.4879C157.921 16.1383 159.054 17.0326 160.325 17.3497L162.312 17.8456C163.366 18.103 163.843 18.4824 163.843 19.3171C163.843 20.3307 163.127 20.9079 161.875 20.9079C160.523 20.9079 159.829 20.2521 159.61 18.6044L157.504 19.2006C157.623 20.9106 159.214 21.9621 161.618 21.9621C164.301 21.9621 165.751 20.7101 165.751 18.7236C165.751 16.8564 164.458 16.0814 163.108 15.7426L161.2 15.2656C160.247 15.0272 159.829 14.5908 159.829 13.954C159.829 13.1599 160.504 12.683 161.518 12.683C162.71 12.683 163.444 13.3388 163.545 14.5908L165.531 13.9946C165.29 12.599 163.919 11.6261 161.715 11.6261ZM171.569 20.8646C170.038 20.8646 169.184 19.4147 169.184 16.7914C169.184 14.1274 170.038 12.7182 171.569 12.7182C173.1 12.7182 173.954 14.1491 173.954 16.7914C173.954 19.4553 173.097 20.8646 171.569 20.8646ZM171.569 11.6261C168.45 11.6261 166.721 13.9513 166.721 16.7914C166.721 19.6315 168.45 21.9567 171.569 21.9567C174.688 21.9567 176.417 19.6315 176.417 16.7914C176.417 13.9513 174.688 11.6261 171.569 11.6261ZM183.013 11.6261C181.542 11.6261 180.729 12.2629 180.271 13.0759H180.152V11.8239H177.807V21.7589H180.152V15.3415C180.152 13.8727 180.908 13.0163 182.119 13.0163C183.293 13.0163 183.807 13.7914 183.807 14.9648V21.7589H186.152V14.9431C186.152 12.8971 185.078 11.6261 183.013 11.6261ZM39.0677 7.85101H36.6042V18.122C36.6042 19.7914 35.9674 20.7833 34.4579 20.7833C32.9674 20.7833 32.3116 19.7291 32.3116 17.9215V16.0136L29.8481 16.6288V17.4824C29.8481 20.0841 31.1408 22.0732 34.4579 22.0732C37.775 22.0732 39.0677 20.0868 39.0677 17.4824V7.85101ZM53.8888 7.85101H51.5446V21.7589H53.8888V15.3415C53.8888 13.8727 54.6449 13.0163 55.8563 13.0163C57.0297 13.0163 57.5446 13.7914 57.5446 14.9648V21.7589H59.8888V14.9431C59.8888 12.8971 58.8156 11.6261 56.7506 11.6261C55.279 11.6261 54.466 12.2629 54.008 13.0759H53.8888V7.85101ZM125.336 7.85101H122.873V18.122C122.873 19.7914 122.236 20.7833 120.726 20.7833C119.236 20.7833 118.58 19.7291 118.58 17.9215V16.0136L116.116 16.6288V17.4824C116.116 20.0841 117.409 22.0732 120.726 22.0732C124.043 22.0732 125.336 20.0868 125.336 17.4824V7.85101ZM140.157 7.85101H137.813V21.7589H140.157V15.3415C140.157 13.8727 140.913 13.0163 142.125 13.0163C143.298 13.0163 143.813 13.7914 143.813 14.9648V21.7589H146.157V14.9431C146.157 12.8971 145.084 11.6261 143.019 11.6261C141.547 11.6261 140.734 12.2629 140.276 13.0759H140.157V7.85101ZM107.612 20.6261C105.705 20.6261 104.534 19.0759 104.534 17.4282C104.534 16.3957 104.992 15.4418 105.745 14.9052L110.236 19.8131C109.401 20.309 108.466 20.6261 107.612 20.6261ZM111.984 18.1816L108.089 13.8889C108.786 13.6098 109.461 13.5123 110.016 13.5123C111.626 13.5123 112.618 14.4472 112.618 16.057C112.621 16.7724 112.42 17.5068 111.984 18.1816ZM107.553 13.3144L106.699 12.3605C105.943 11.5258 105.726 11.0082 105.726 10.393C105.726 9.24125 106.461 8.58543 107.612 8.58543C108.786 8.58543 109.48 9.26022 109.48 10.4933C109.48 11.6261 108.924 12.6992 107.553 13.3144ZM107.672 7.53394C104.929 7.53394 103.58 9.0651 103.58 10.9702C103.58 12.0028 104.016 13.038 105.171 14.2873L105.19 14.328C103.244 15.2629 102.35 16.7724 102.35 18.3226C102.35 20.3686 103.919 22.0787 106.344 22.0787C107.734 22.0787 109.363 21.5014 110.835 20.4689L112.027 21.7616H115.146V21.6613L112.604 18.8591C113.677 17.5881 114.293 16.1979 114.293 14.9838C114.293 13.4743 113.279 12.4608 111.691 12.4608C110.856 12.4608 109.921 12.6992 109.306 12.9377L109.266 12.8591C110.775 12.0434 111.412 11.29 111.412 10.2358C111.406 8.72635 110.057 7.53394 107.672 7.53394Z",
                                fill: "white"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "banner-default-title" }, [
                          _vm._v("Acuvue iLearn")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "banner-default-slogan" }, [
                          _vm._v("专业视光培训 · 助力职业成长")
                        ])
                      ])
                    ])
                  ])
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "quick-nav-grid" }, [
        _c(
          "div",
          {
            staticClass: "nav-grid-item",
            on: {
              click: function($event) {
                return _vm.tab_tap(1)
              }
            }
          },
          [
            _c("div", { staticClass: "nav-grid-icon" }, [
              _c("svg", { attrs: { viewBox: "0 0 24 24", fill: "none" } }, [
                _c("path", {
                  attrs: {
                    d: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("全部课程")])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nav-grid-item",
            on: {
              click: function($event) {
                return _vm.tab_tap(2)
              }
            }
          },
          [
            _c("div", { staticClass: "nav-grid-icon" }, [
              _c("svg", { attrs: { viewBox: "0 0 24 24", fill: "none" } }, [
                _c("path", {
                  attrs: {
                    d: "M9 11l3 3L22 4",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("在线考试")])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nav-grid-item",
            on: {
              click: function($event) {
                return _vm.tab_tap(3)
              }
            }
          },
          [
            _c("div", { staticClass: "nav-grid-icon" }, [
              _c("svg", { attrs: { viewBox: "0 0 24 24", fill: "none" } }, [
                _c("circle", {
                  attrs: {
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "2"
                  }
                }),
                _vm._v(" "),
                _c("polyline", {
                  attrs: {
                    points: "12,6 12,12 16,14",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("培训记录")])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nav-grid-item",
            on: {
              click: function($event) {
                return _vm.tab_tap(4)
              }
            }
          },
          [
            _c("div", { staticClass: "nav-grid-icon" }, [
              _c("svg", { attrs: { viewBox: "0 0 24 24", fill: "none" } }, [
                _c("circle", {
                  attrs: {
                    cx: "12",
                    cy: "8",
                    r: "6",
                    stroke: "currentColor",
                    "stroke-width": "2"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M9 14l-1 8 4-2 4 2-1-8",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("我的证书")])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.categoryList.length > 0 || _vm.loading
        ? _c("div", { ref: "stickyAnchor", staticClass: "sticky-anchor" })
        : _vm._e(),
      _vm._v(" "),
      _vm.categoryList.length > 0 || _vm.loading
        ? _c(
            "div",
            {
              ref: "courseSection",
              staticClass: "course-section",
              class: { "is-sticky": _vm.isCourseSticky }
            },
            [
              _c("div", { staticClass: "section-header" }, [
                _c("span", { staticClass: "section-title" }, [
                  _vm._v("推荐课程")
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "section-more",
                    on: {
                      click: function($event) {
                        return _vm.tab_tap(1)
                      }
                    }
                  },
                  [_vm._v("更多 ›")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "delivery-layout" }, [
                _c(
                  "div",
                  { staticClass: "sidebar-nav" },
                  [
                    _vm.loading
                      ? _vm._l(7, function(i) {
                          return _c("div", {
                            key: i,
                            staticClass: "sidebar-item-sk"
                          })
                        })
                      : [
                          _c(
                            "div",
                            {
                              staticClass: "sidebar-item",
                              class: { active: _vm.activeTabIndex === -1 },
                              on: {
                                click: function($event) {
                                  return _vm.selectTab(-1)
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "sidebar-text" }, [
                                _vm._v("全部")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.flatCategoryList, function(
                            category,
                            catIndex
                          ) {
                            return _c(
                              "div",
                              {
                                key: category.Id,
                                staticClass: "sidebar-item",
                                class: {
                                  active: _vm.activeTabIndex === catIndex
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.selectTab(catIndex)
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "sidebar-text" }, [
                                  _vm._v(_vm._s(category.Name))
                                ])
                              ]
                            )
                          })
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { key: _vm.activeTabIndex, staticClass: "courses-panel" },
                  [
                    _vm.loading || _vm.coursesLoading
                      ? _c(
                          "div",
                          { staticClass: "course-grid" },
                          _vm._l(6, function(i) {
                            return _c(
                              "div",
                              { key: i, staticClass: "skeleton-v-card" },
                              [
                                _c("div", { staticClass: "skeleton-v-thumb" }),
                                _vm._v(" "),
                                _vm._m(0, true)
                              ]
                            )
                          }),
                          0
                        )
                      : _c(
                          "div",
                          { staticClass: "course-grid" },
                          [
                            _vm._l(_vm.displayCourses, function(course, index) {
                              return _c(
                                "div",
                                {
                                  key: course.Id,
                                  staticClass: "course-card-v",
                                  class: {
                                    "course-locked": !course.IsUnlocked
                                  },
                                  style: { animationDelay: index * 0.05 + "s" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleCourseClick(course)
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "card-v-thumb" }, [
                                    _c("div", {
                                      staticClass: "thumb-skeleton"
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      directives: [
                                        {
                                          name: "lazy",
                                          rawName: "v-lazy",
                                          value: course.Thumbnail,
                                          expression: "course.Thumbnail"
                                        }
                                      ],
                                      staticClass: "thumb-img",
                                      attrs: { alt: course.Subject }
                                    }),
                                    _vm._v(" "),
                                    !course.IsUnlocked
                                      ? _c(
                                          "div",
                                          { staticClass: "thumb-lock-v" },
                                          [_c("span", [_vm._v("🔒")])]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    course.Duration && course.Duration > 0
                                      ? _c(
                                          "div",
                                          { staticClass: "thumb-duration-v" },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.formatDuration(
                                                    course.Duration
                                                  )
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "card-v-body" }, [
                                    _c("p", { staticClass: "card-v-title" }, [
                                      _vm._v(_vm._s(course.Subject))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "card-v-footer" },
                                      [
                                        course.IsUnlocked
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "card-v-status unlocked"
                                              },
                                              [_vm._v("▶ 学习")]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "card-v-status locked card-v-status-link",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.handleCourseClick(
                                                      course
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("点击了解解锁规则")]
                                            ),
                                        _vm._v(" "),
                                        _vm.getLinkExtension(course.Link)
                                          ? _c(
                                              "span",
                                              { staticClass: "card-v-tag" },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.getLinkExtension(
                                                        course.Link
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ])
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm.displayCourses.length === 0
                              ? _c("div", { staticClass: "empty-courses-v" }, [
                                  _c("span", [_vm._v("暂无课程")])
                                ])
                              : _vm._e()
                          ],
                          2
                        )
                  ]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isCourseSticky
        ? _c("div", {
            staticClass: "sticky-placeholder",
            style: { height: _vm.stickyPlaceholderHeight + "px" }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.categoryList.length === 0
        ? _c("div", { staticClass: "empty-state" }, [
            _c("div", { staticClass: "empty-icon" }, [_vm._v("📭")]),
            _vm._v(" "),
            _c("p", { staticClass: "empty-text" }, [
              _vm._v("暂无课程，敬请期待")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "van-dialog",
        {
          attrs: {
            title: "请输入课程密码",
            "show-cancel-button": "",
            "confirm-button-color": "#d51900"
          },
          on: {
            confirm: _vm.confirm_pass,
            cancel: function($event) {
              _vm.show_password = false
            }
          },
          model: {
            value: _vm.show_password,
            callback: function($$v) {
              _vm.show_password = $$v
            },
            expression: "show_password"
          }
        },
        [
          _c(
            "div",
            { staticClass: "password-input-wrapper" },
            [
              _c("van-field", {
                staticClass: "password-field",
                attrs: {
                  type: "password",
                  "input-align": "center",
                  placeholder: "请输入密码"
                },
                model: {
                  value: _vm.PassWord_value,
                  callback: function($$v) {
                    _vm.PassWord_value = $$v
                  },
                  expression: "PassWord_value"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("unlock-tip-dialog", {
        attrs: {
          show: _vm.show_unlock_tip,
          "unlock-data": _vm.unlockTipData,
          loading: _vm.unlockTipLoading
        },
        on: {
          "update:show": function($event) {
            _vm.show_unlock_tip = $event
          },
          "go-course": _vm.goToPreCourse
        }
      }),
      _vm._v(" "),
      _c(
        "van-dialog",
        {
          attrs: {
            title: _vm.currentPopup ? _vm.currentPopup.Title : "",
            "show-confirm-button":
              !!_vm.currentPopup && !!_vm.currentPopup.ButtonText,
            "confirm-button-text": _vm.currentPopup
              ? _vm.currentPopup.ButtonText
              : "确定"
          },
          on: { confirm: _vm.onPopupConfirm },
          model: {
            value: _vm.showBannerPopup,
            callback: function($$v) {
              _vm.showBannerPopup = $$v
            },
            expression: "showBannerPopup"
          }
        },
        [
          _vm.currentPopup
            ? _c("div", { staticClass: "banner-popup-content" }, [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.currentPopup.Content) }
                })
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.showGuideFullscreen && _vm.platformGuideItem
        ? _c("div", { staticClass: "guide-fullscreen-overlay" }, [
            _c("div", { staticClass: "guide-fullscreen-content" }, [
              !_vm.isGuideVideoFullscreen
                ? _c("div", { staticClass: "guide-header" }, [
                    _c("h2", { staticClass: "guide-title" }, [
                      _vm._v("🎬 平台操作指引")
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "guide-video-wrapper" }, [
                _c("video", {
                  ref: "guideVideo",
                  staticClass: "guide-video",
                  attrs: {
                    src: _vm.platformGuideItem.VideoUrl,
                    controls: "",
                    playsinline: "",
                    "webkit-playsinline": "",
                    "x5-video-player-type": "h5",
                    "x5-video-player-fullscreen": "true"
                  },
                  on: {
                    ended: _vm.onGuideVideoEnded,
                    play: _vm.onGuideVideoPlay,
                    pause: _vm.onGuideVideoPause,
                    fullscreenchange: _vm.onGuideFullscreenChange,
                    webkitfullscreenchange: _vm.onGuideFullscreenChange
                  }
                }),
                _vm._v(" "),
                !_vm.guideVideoStarted
                  ? _c(
                      "div",
                      {
                        staticClass: "guide-poster-overlay",
                        on: { click: _vm.playGuideVideo }
                      },
                      [
                        _c("img", {
                          staticClass: "guide-poster-img",
                          attrs: { src: _vm.platformGuideItem.CoverUrl }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "guide-play-btn" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                viewBox: "0 0 24 24",
                                fill: "currentColor"
                              }
                            },
                            [_c("path", { attrs: { d: "M8 5v14l11-7z" } })]
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isGuideVideoFullscreen &&
                !_vm.guideVideoEnded &&
                (_vm.guideVideoStarted || !_vm.isGuideForced)
                  ? _c("div", { staticClass: "guide-skip-area" }, [
                      !_vm.isGuideForced || _vm.guideVideoPlayedSeconds >= 3
                        ? _c(
                            "button",
                            {
                              staticClass: "guide-skip-btn-inline",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.onSkipGuide.apply(null, arguments)
                                }
                              }
                            },
                            [_vm._v("\n            跳过 ›\n          ")]
                          )
                        : _c(
                            "span",
                            { staticClass: "guide-skip-countdown-inline" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    Math.max(0, 3 - _vm.guideVideoPlayedSeconds)
                                  ) +
                                  "s\n          "
                              )
                            ]
                          )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isGuideVideoFullscreen &&
                _vm.guideVideoPlayedSeconds >= 3 &&
                !_vm.guideVideoEnded
                  ? _c(
                      "button",
                      {
                        staticClass: "guide-skip-btn-fullscreen",
                        on: { click: _vm.onSkipGuide }
                      },
                      [_vm._v("\n          跳过 ›\n        ")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.platformGuideItem.Description && !_vm.isGuideVideoFullscreen
                ? _c("div", { staticClass: "guide-description" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.platformGuideItem.Description) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isGuideVideoFullscreen
                ? _c("div", { staticClass: "guide-actions" }, [
                    _vm.guideVideoEnded
                      ? _c(
                          "button",
                          {
                            staticClass: "guide-complete-btn",
                            on: { click: _vm.markGuideViewed }
                          },
                          [_vm._v("\n          开始使用\n        ")]
                        )
                      : _c("p", { staticClass: "guide-tip" }, [
                          _vm._v("请观看平台操作指引视频")
                        ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.showSkipConfirm
              ? _c("div", { staticClass: "skip-confirm-overlay" }, [
                  _c("div", { staticClass: "skip-confirm-box" }, [
                    _c("p", { staticClass: "skip-confirm-text" }, [
                      _vm._v("确定要跳过平台操作指引吗？")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "skip-confirm-hint" }, [
                      _vm._v("您可以稍后在首页点击「平台操作指引」继续观看")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "skip-confirm-actions" }, [
                      _c(
                        "button",
                        {
                          staticClass: "skip-cancel-btn",
                          on: { click: _vm.cancelSkipGuide }
                        },
                        [_vm._v("继续观看")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "skip-confirm-btn",
                          on: { click: _vm.confirmSkipGuide }
                        },
                        [_vm._v("确认跳过")]
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "skeleton-v-body" }, [
      _c("div", { staticClass: "skeleton-line skeleton-title-line" }),
      _vm._v(" "),
      _c("div", { staticClass: "skeleton-line skeleton-title-line-short" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7eb2bc79", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb2bc79","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = null
// module chunks = 